import React, { useCallback, useState } from 'react';

import CN from 'components/experiment/hooks/HooksPage.module.scss';
import Button from 'components/form/Button.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

const L = logger('DialogExample');

const DialogExample = ({ title, counter, onChange }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const toggleDialog = useCallback(
    () => {
      onChange(-999);
      delayed(5000, () => onChange(-444));
      setIsDialogOpen(!isDialogOpen);
    },
    [isDialogOpen, onChange],
  );

  L.debug('()', { counter, isDialogOpen });

  return (
    <div data-bem="DialogExample" className={CN.col}>
      <div className={CN.row}>
        <Button onClick={toggleDialog}  variant="primary" casing="dialog"  variantInvert>
          Pop Up !
        </Button>
        <dialog open={isDialogOpen}>
          <p>
            <strong>{title}</strong>
          </p>
          <p>Greetings, the counter is: {fromAnyToTrimmed(counter)}</p>
        </dialog>
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default DialogExample;
